import { AnyArray } from 'immer/dist/types/types-internal'
import { useMemo } from 'react'

export function useStableArray<Arr extends AnyArray>(arr: Arr = [] as unknown as Arr) {
  return useMemo(() => arr, [arr.length, ...arr])
}
